import React, { useEffect, useRef } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Seo from "../components/Seo";
import { StaticImage, getImage, GatsbyImage } from "gatsby-plugin-image";

import "../../scss/main.scss";

export default function Blog() {
	const cookieContainerRef = useRef();
	useEffect(() => {
		let script = document.createElement("script");
		script.id = "CookieDeclaration";
		script.src =
			"https://consent.cookiebot.com/af2eb560-865b-442a-b6a0-60f8dff7846a/cd.js";
		script.type = "text/javascript";
		script.async = true;

		cookieContainerRef.current.appendChild(script);
	}, []);

	return (
		<>
			<Seo
				title="Cookie Policy | Edyn Care"
				description="Review the cookies and tracking technologies used on the Edyn Care website and manage your consent preferences."
				path="/cookies/"
			/>
			<div className="container edyn-commercial-shell edyn-article-shell">
				<Header />
				<main className="blog-post">
					<div className="blog-post__above-the-fold">
						<StaticImage
							src="../../static/assets/marketing-site/images/our-approach-01.png"
							objectFit="contain"
							placeholder="blurred"
							loading="eager"
						/>
						<div>
							<h1 className="blog-post__above-the-fold-title">Cookies</h1>
						</div>
						<StaticImage
							src="../../static/assets/marketing-site/images/our-approach-02.png"
							objectFit="contain"
							placeholder="blurred"
							loading="eager"
						/>
					</div>
					<section className="blog-post-section">
						<div className="blog-post__content">
							<div ref={cookieContainerRef} />
						</div>
					</section>
				</main>
				<Footer includeCTA={false} />
			</div>
		</>
	);
}
